import styled from "styled-components";

export const Button = styled.a`
    display: block;
    width: 100%;
    border-radius: 10px;
    background-color: #fff;
    color: #2c3e50;
    outline: none;
    border: none;
    padding: 12.5px;
    margin-bottom: 0.5em;
    text-align: center;
    text-decoration: none;
    font-size: 1em;
    cursor: pointer;
    transition: transform 0.8s,
        background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
        box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
        border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
        0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    &:hover {
        box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
            0px 4px 5px 0px rgba(0, 0, 0, 0.14),
            0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    }
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: inherit;
    width: 100%;
    padding: 1.2em;
    box-sizing: border-box;
`;

export const Content = styled.div`
    width: 100%;
    max-width: 700px;
    text-align: center;
`;

export const Description = styled.p`
    color: #fff;
    font-size: 1.1em;
    font-weight: 300;
    line-height: 1.2;
    @media (min-width: 1024px) {
        font-size: 1.6em;
    }
`;

export const Divider = styled.div`
    width: 100%;
    height: 3px;
    margin-bottom: 0.5em;
    background-color: rgb(68, 220, 255);
    background-image: -moz-linear-gradient(
        90deg,
        rgba(250, 47, 92, 1) 0%,
        rgba(202, 88, 239, 1) 50%,
        rgba(68, 220, 255, 1) 100%
    );
    background-image: -webkit-linear-gradient(
        90deg,
        rgba(250, 47, 92, 1) 0%,
        rgba(202, 88, 239, 1) 50%,
        rgba(68, 220, 255, 1) 100%
    );
    background-image: linear-gradient(
        90deg,
        rgba(250, 47, 92, 1) 0%,
        rgba(202, 88, 239, 1) 50%,
        rgba(68, 220, 255, 1) 100%
    );
    @media (min-width: 1024px) {
        background-image: -moz-linear-gradient(
            90deg,
            rgba(68, 220, 255, 1) 0%,
            rgba(202, 88, 239, 1) 50%,
            rgba(250, 47, 92, 1) 100%
        );
        background-image: -webkit-linear-gradient(
            90deg,
            rgba(68, 220, 255, 1) 0%,
            rgba(202, 88, 239, 1) 50%,
            rgba(250, 47, 92, 1) 100%
        );
        background-image: linear-gradient(
            90deg,
            rgba(68, 220, 255, 1) 0%,
            rgba(202, 88, 239, 1) 50%,
            rgba(250, 47, 92, 1) 100%
        );
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#50cfff",endColorstr="#f63167",GradientType=1);
    }
`;

export const Hero = styled.div`
    background: #2c3e50;
    background-image: url(/images/background.png);
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
    flex: 1 1 100%;
    justify-content: center;
    align-items: center;
    height: 100vh;
    border-bottom: solid 1.2em transparent;
    background-clip: padding-box;
    box-sizing: border-box;
    /* &:before {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: -1;
        border-radius: inherit;
        background: rgb(68, 220, 255);
        background: -moz-linear-gradient(
            90deg,
            rgba(250, 47, 92, 1) 0%,
            rgba(202, 88, 239, 1) 50%,
            rgba(68, 220, 255, 1) 100%
        );
        background: -webkit-linear-gradient(
            90deg,
            rgba(250, 47, 92, 1) 0%,
            rgba(202, 88, 239, 1) 50%,
            rgba(68, 220, 255, 1) 100%
        );
        background: linear-gradient(
            90deg,
            rgba(250, 47, 92, 1) 0%,
            rgba(202, 88, 239, 1) 50%,
            rgba(68, 220, 255, 1) 100%
        );
    } */

    /* @media (min-width: 1024px) {
        background-position: center center;
        &:before {
            background-image: -moz-linear-gradient(
                90deg,
                rgba(68, 220, 255, 1) 0%,
                rgba(202, 88, 239, 1) 50%,
                rgba(250, 47, 92, 1) 100%
            );
            background-image: -webkit-linear-gradient(
                90deg,
                rgba(68, 220, 255, 1) 0%,
                rgba(202, 88, 239, 1) 50%,
                rgba(250, 47, 92, 1) 100%
            );
            background-image: linear-gradient(
                90deg,
                rgba(68, 220, 255, 1) 0%,
                rgba(202, 88, 239, 1) 50%,
                rgba(250, 47, 92, 1) 100%
            );
        }
    } */
`;

export const Link = styled.a`
    color: #fff;
    text-align: center;
    margin-bottom: 1.8em;
    text-decoration: underline;
    text-decoration-color: transparent;
    transition: 0.3s;

    /*add those for opera and mozilla support*/
    -webkit-text-decoration-color: transparent;
    -moz-text-decoration-color: transparent;
    &:hover {
        text-decoration-color: inherit;

        /*add those for opera and mozilla support*/
        -webkit-text-decoration-color: inherit;
        -moz-text-decoration-color: inherit;
    }
`;

export const Logo = styled.img`
    width: 100%;
`;

export const LogoWrapper = styled.figure`
    margin: 0;
    padding: 0;
    width: 150px;
    margin-bottom: 3em;
    @media (min-width: 1024px) {
        display: none;
    }
`;

export const SignIn = styled.div`
    display: block;
    width: 100%;
    min-width: 320px;
    max-width: 400px;
`;

export const SignInContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 1.2em;
    box-sizing: border-box;
`;

export const Title = styled.h1`
    color: #fff;
    font-size: 2em;
    font-family: Roboto;
    font-weight: 400;
    @media (min-width: 1024px) {
        font-size: 3em;
    }
    @media (max-height: 650px) {
        font-size: 1.8em;
    }
`;
